var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.2852 22.4829C10.7142 22.9269 11.4282 22.9269 11.8722 22.4829C12.3012 22.0539 12.3012 21.3399 11.8722 20.9119L3.82523 12.8649L30.3792 12.8649C30.9982 12.8639 31.4902 12.3719 31.4902 11.7529C31.4902 11.1339 30.9982 10.6259 30.3792 10.6259L3.82523 10.6259L11.8722 2.59392C12.3012 2.14992 12.3012 1.43492 11.8722 1.00692C11.4282 0.562919 10.7132 0.56292 10.2852 1.00692L0.333234 10.9589C-0.110766 11.3879 -0.110766 12.1019 0.333234 12.5299L10.2852 22.4829Z","fill":"white"}));
}

Back.defaultProps = {"width":"32","height":"23","viewBox":"0 0 32 23","fill":"none"};

module.exports = Back;

Back.default = Back;
